module.exports = __webpack_public_path__ + "static/img/asher-2.38dca83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/asher-2.png
// module id = qk2m
// module chunks = 1